import { getQueryParam, scrollToElement } from 'www/utils'

export const scrollToReviewsContainer = () => {
  const reviewsContainerElement = document.querySelector('.b-reviews-page__container')

  if (reviewsContainerElement) {
    setTimeout(() => scrollToElement(reviewsContainerElement))
  }
}

export const scrollToReviewOrReviewsContainer = () => {
  if (getQueryParam('rate_id')) {
    scrollToReviewsContainer()

    return
  }

  const [, reviewToScrollId] = window.location.hash.match(/^#rate-(\d+)/) || []

  if (!reviewToScrollId) {
    return
  }

  const reviewToScrollElement = document.querySelector(`[data-review-id="${reviewToScrollId}"]`)
  const isReviewToScrollExistsOrVisible = reviewToScrollElement && !reviewToScrollElement.classList.contains('d-none')

  if (!isReviewToScrollExistsOrVisible) {
    scrollToReviewsContainer()

    return
  }

  setTimeout(() => scrollToElement(reviewToScrollElement))
}
